import React, { useState } from 'react';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventIcon from '@mui/icons-material/Event';
import AdminPage from './AdminPage';
import AppShell from './AppShell';
import ClientCompanyTracking from './ClientCompanyTracking';
import ClientHolidays from './ClientHolidays';
import Reminders from './Reminders';

/**
 * Role splitter. Admin → AdminPage (its own AppShell + full menu).
 * Client → AppShell with a focused 3-item menu:
 *   • Firma Takibi   — kendi firmasının takip kartı (status read-only,
 *                       dosya indir/yükle, kendi dosyalarını silebilir)
 *   • Hatırlatıcılar — adminin atadıkları + kendi oluşturdukları
 *   • Resmi Tatiller — read-only yıllık tatil listesi
 */
const CLIENT_MENU = [
  { key: 0, label: 'Firma Takibi',     icon: <AssignmentTurnedInIcon /> },
  { key: 1, label: 'Hatırlatıcılar',   icon: <NotificationsActiveIcon /> },
  { key: 2, label: 'Resmi Tatiller',   icon: <EventIcon /> },
];

function MainPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  const info = (() => {
    try { return JSON.parse(localStorage.getItem('companyInfo') || 'null'); }
    catch { return null; }
  })();

  if (info?.role === 'Admin') {
    return <AdminPage />;
  }

  const menuItems = CLIENT_MENU.map((m) => ({
    ...m,
    active: selectedTab === m.key,
    onClick: () => setSelectedTab(m.key),
  }));
  const title = CLIENT_MENU.find((m) => m.key === selectedTab)?.label || 'Peak Portal';

  return (
    <AppShell title={title} brand="Kullanıcı" menuItems={menuItems}>
      {selectedTab === 0 && <ClientCompanyTracking />}
      {selectedTab === 1 && <Reminders />}
      {selectedTab === 2 && <ClientHolidays />}
    </AppShell>
  );
}

export default MainPage;
